import React, { useEffect, useRef } from 'react';
import { useLocation, Route, Switch, Redirect } from 'react-router-dom';

import { Container } from 'reactstrap';

import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import AdminFooter from 'components/Footers/AdminFooter.js';
import Sidebar from 'components/Sidebar/Sidebar.js';
import Logo from '../assets/logo.png';

import routes from 'routes.js';

const screenUser = [
  {
    name: 'Usuários',
    show: true,
  },
  {
    name: 'Usuário',
    show: false,
  },
  {
    name: 'Novo Usuário',
    show: false,
  },
];

const screenRoute = [
  {
    name: 'Rota',
    show: false,
  },
  {
    name: 'Nova Rota',
    show: false,
  },
];

const screenCity = [
  {
    name: 'Cidade',
    show: false,
  },
  {
    name: 'Nova Cidade',
    show: false,
  },
];

const screenClients = [
  {
    name: 'Cliente',
    show: false,
  },
  {
    name: 'Novo Cliente',
    show: false,
  },
];

const screenProducts = [
  {
    name: 'Produto',
    show: false,
  },
  {
    name: 'Novo Produto',
    show: false,
  },
];

const screenWhatsapp = [
  {
    name: 'WhatsApp',
    show: true,
  },
];

const routesByServer = [
  {
    name: 'Dashboard',
    show: true,
  },
  {
    name: 'Vendas',
    show: true,
  },
  {
    name: 'Relatórios',
    show: true,
  },
  {
    name: 'Relatórios de Pagamentos',
    show: false,
  },
  {
    name: 'Pré-venda',
    show: false,
  },
  // {
  //   name: 'Pré-Vendas Realizadas',
  //   show: true,
  // },
  // {
  //   name: 'Pré-Venda Realizada',
  //   show: false,
  // },
  {
    name: 'Criar Venda',
    show: false,
  },
  {
    name: 'Perfil de Usuário',
    show: false,
  },
  {
    name: 'Sincronizações Pendentes',
    show: false,
  },
  {
    name: 'Cadastros',
    subSideBar: [
      {
        name: 'Clientes',
      },
      {
        name: 'Produtos',
      },
      {
        name: 'Rotas',
      },
      {
        name: 'Cidades',
      },
    ],
  },
  ...screenUser,
  ...screenRoute,
  ...screenClients,
  ...screenProducts,
  ...screenCity,
  ...screenWhatsapp,
];

const Admin = (props) => {
  const mainContent = useRef(null);
  const location = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const handleSubSideBar = (subSideBar) => {
    let subMenu = [];
    subSideBar.forEach((sub) => {
      let item = routes.filter((route) => {
        return route.name === sub.name;
      });
      subMenu.push(item[0]);
    });
    return subMenu;
  };

  const changeRoutes = () => {
    let result = [];
    routesByServer.forEach((itemMenu) => {
      routes.forEach((itemMenuRoutes) => {
        if (itemMenu.name === itemMenuRoutes.name) {
          if (itemMenu.subSideBar !== undefined) {
            const subItems = handleSubSideBar(itemMenu.subSideBar);
            result.push({
              ...itemMenuRoutes,
              subSideBar: subItems,
              show: itemMenu.show,
            });
            subItems.forEach((subItem) => {
              result.push({ show: false, ...subItem });
            });
          } else {
            result.push({ ...itemMenuRoutes, show: itemMenu.show });
          }
        }
      });
    });
    return result;
  };

  const getRoutes = () => {
    return changeRoutes().map((prop, key) => {
      if (prop.layout === '/admin') {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return 'Brand';
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={changeRoutes()}
        logo={{
          innerLink: '/admin/index',
          imgSrc: Logo,
          imgAlt: 'DNG - Dashboard',
        }}
      />
      <div className='main-content' ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes()}
          <Redirect from='*' to='/admin/index' />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
